/*
 *
 * ZendeskVerify actions
 *
 */

import { VERIFY_ZENDESK } from './constants';
import { defineAction } from 'utils/action-helper';

export const verifyZendesk = {
  start: ({ payload, metadata }) => defineAction({ type: VERIFY_ZENDESK.START, payload, metadata }),
  success: () => {
    return defineAction({ type: VERIFY_ZENDESK.SUCCESS });
  },
  error: ({ error }) =>
    defineAction({
      type: VERIFY_ZENDESK.ERROR,
      payload: {
        error,
      },
    }),
};
